import { forwardRef } from 'react';
import { Group } from 'three';

import { GroupProps } from '@react-three/fiber';
import { useForkRef } from '@spazious/react-hooks';

import { SelectBoxHookOptions, useSelectBox } from './useSelectBox.js';

export interface SelectBoxProps extends GroupProps, SelectBoxHookOptions {}

/**
 * SelectBox component
 */
export const SelectBox = forwardRef<Group, SelectBoxProps>(
  (
    { enabled, backgroundColor, borderColor, borderStyle, borderWidth, onSelect, ...restProps },
    fowardedRef
  ) => {
    const setElementRef = useSelectBox({
      enabled,
      backgroundColor,
      borderColor,
      borderStyle,
      borderWidth,
      onSelect,
    });

    return (
      <group
        ref={useForkRef(setElementRef as React.Ref<Group>, fowardedRef)}
        {...restProps}
      ></group>
    );
  }
);
